import { Col, Flex, notification, Row } from "antd";

import { useEffect } from "react";
import { useAuditInfo } from "audit/queries";
import { FieldAuditorDashboardAuditAppointmentsCard } from "./field-auditor-dashboard-audit-appointments-card/FieldAuditorDashboardAuditAppointmentsCard";
import { FieldAuditorMapCard } from "./field-auditor-map-card/FieldAuditorMapCard";
import variables from "../../../../_variables.scss";
import { NotesList } from "notes/components";
import { useBoundStore } from "store";

export const FieldAuditorDashboard = () => {
  const { currentOrganization } = useBoundStore();
  const {
    data: auditInfo,
    isSuccess,
    error,
    refetch,
  } = useAuditInfo(currentOrganization?.id);
  const [api, notificationContextHolder] = notification.useNotification();

  useEffect(() => {
    if (error) {
      api.error({
        message: "Error",
        description: (error as Error)?.message,
      });
    }
  }, [error, api]);

  return (
    <Flex vertical gap={variables.largeGap}>
      {notificationContextHolder}
      <Row gutter={{ xs: 4, sm: 8, md: 16, lg: 32 }} justify={"space-between"}>
        <Col span={16}>
          <FieldAuditorMapCard loading={!isSuccess} auditAppointments={auditInfo?.auditAppointments} />
        </Col>
        <Col span={8}>
          <NotesList title={"My Project Notes"} showCard />
        </Col>
      </Row>
      <FieldAuditorDashboardAuditAppointmentsCard loading={!isSuccess} auditAppointments={auditInfo?.auditAppointments} />
    </Flex>
  );
};
